/* Small navigation enhancements. Product variants, gallery and cart remain owned by Impact. */
(() => {
  const selector = '.ally-site-header__dropdown, .ally-mobile-nav';
  const closeMenus = (except, restoreFocus = false) => {
    document.querySelectorAll(selector).forEach(menu => {
      if (menu !== except && menu.open) {
        menu.open = false;
        if (restoreFocus && menu.contains(document.activeElement)) menu.querySelector('summary')?.focus();
      }
    });
  };
  document.addEventListener('click', event => {
    const menu = event.target.closest(selector);
    closeMenus(menu);
    if (menu && event.target.closest('a')) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenus(null, true);
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('.ally-site-header')) closeMenus();
  });
  const observeHeader = () => {
    const header = document.querySelector('.shopify-section--ally-site-header');
    if (!header || header.dataset.measured) return;
    header.dataset.measured = 'true';
    new ResizeObserver(entries => {
      const wrapper = entries[0].target;
      const root = document.documentElement.style;
      root.setProperty('--ally-header-height', `${wrapper.offsetHeight}px`);
      root.setProperty('--header-height', `${wrapper.querySelector('.ally-site-header')?.offsetHeight || 0}px`);
      root.setProperty('--announcement-bar-height', `${wrapper.querySelector('.ally-announcement')?.offsetHeight || 0}px`);
    }).observe(header);
  };
  observeHeader();
  document.addEventListener('shopify:section:load', observeHeader);
})();
